import { TextField, Stack, InputAdornment, Button } from "@mui/material"
import { useState } from "react"
import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import ProgramCard from "../cards/ProgramCard"
import AddProgram from "../modals/AddProgram"
import DeleteProgram from "../modals/DeleteProgram"
import { getAllPrograms, getProgramFilters, getProgramSort } from "../../api"

import ListData from "../common/ListData"

const Programs = () => {
  const [search, setSearch] = useState("")
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [fetchData, setFetchData] = useState(false)

  const handleSearchChange = (event) => setSearch(event.target.value)

  const openEditModal = (item) => {
    setSelectedItem(item)
    setEditModal(true)
  }
  const closeEditModal = () => setEditModal(false)
  const openDeleteModal = (item) => {
    setSelectedItem(item)
    setDeleteModal(true)
  }
  const closeDeleteModal = () => setDeleteModal(false)

  const CTA = () => (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
      <TextField
        value={search}
        onChange={handleSearchChange}
        placeholder="Search Programs..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon />
            </InputAdornment>
          ),
        }}
      />
      <Button onClick={() => openEditModal(null)} variant="contained">
        Add Program
      </Button>
    </Stack>
  )

  return (
    <>
      <ListData
        getFilters={getProgramFilters}
        getSort={getProgramSort}
        getAllData={getAllPrograms}
        initialFilters={{sort: { field: 'degree', order: 'desc' }}}
        HeaderRight={CTA}
        Card={ProgramCard}
        openEditCard={openEditModal}
        openDeleteCard={openDeleteModal}
        refresh={fetchData}
        type="CARD"
      />

      <AddProgram
        isOpen={editModal}
        close={closeEditModal}
        data={selectedItem}
        refresh={() => {
          setFetchData(!fetchData)
        }}
      />
      <DeleteProgram
        isOpen={deleteModal}
        close={closeDeleteModal}
        data={selectedItem}
        refresh={() => {
          setFetchData(!fetchData)
        }}
      />
    </>
  )
}

export default Programs
